module.exports = __webpack_public_path__ + "odstraneni-tetovaze_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_4_after.jpg
// module id = 959
// module chunks = 0